// extracted by mini-css-extract-plugin
export default {"phoneContainer":"KWKE1F3QvF7nKtFhNGu7"};